import React from 'react'
import './capoSelector.scss'
import { Select } from '@mui/joy'
import { Option } from '@mui/joy'
import { IconButton } from '@mui/joy'
import CloseRounded from '@mui/icons-material/CloseRounded';

const CapoSelector = ({ capo, setCapo }) => {
    const numberOfFrets = Array.from({ length: 24 }, (_, i) => i + 1);
    const action = React.useRef(null);

    return (
        <div className='capo-selector'>
            <Select variant='soft' color='primary' value={capo} action={action} placeholder="Select Capo Fret..." onChange={(_event, value) => setCapo(value)}
                {...(capo && {
                    endDecorator: (
                        <IconButton
                            size="sm"
                            variant="plain"
                            color="neutral"
                            onMouseDown={(event) => {
                                event.stopPropagation();
                            }}
                            onClick={() => {
                                setCapo(null);
                                action.current?.focusVisible();
                            }}
                        >
                            <CloseRounded />
                        </IconButton>
                    ),
                    indicator: null,
                })}>
                {
                    numberOfFrets.map((number, key) => (
                        <Option key={key} value={number}>{number}</Option>
                    ))
                }
            </Select>
        </div>
    )
}

export default CapoSelector